import ApiService from './';
import { ConnectDomainParams } from '../params/redux/domain';

/**
 * @heading1: Domain API service.
 * @paragraph: This module provides a set of methods to interact with the Domain API.
 * It handles operations like connect domain, domain detail, fetch domains etc.
 */

const DomainApi = {
    /**
     * @heading3: connect domain
     * @paragraph: Sends a POST request to fetch deal detail based on provided parameters.
     * @param: {string} token - The user's authentication token.
     * @param: {number} id - The parameters required id on which the detail will be fetch.
     * @returns: {Promise<unknown>} - The response containing the deal detail.
     * @separator:
     */
    connectDomain: (token: string, data: ConnectDomainParams) => {
        // Perform a POST request to fetch deal detail with the provided data
        return ApiService.apiHit({
            url: 'create-website',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
  * @heading3: Create Deal
  * @paragraph: Sends a POST request to create a new deal within a stage.
  * @param: {string} token - The user's authentication token.
  * @param: {DealParams} data - The data required to create the deal.
  */
    fetchDomains: (token: string) => {
        return ApiService.apiHit({
            url: 'get-website',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    disconnectDomain: (token: string) => {
        return ApiService.apiHit({
            url: 'disconnect-website',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    updateDomain: (token: string, data: ConnectDomainParams) => {
        return ApiService.apiHit({
            url: 'update-website',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    getDomainDNS: (token: string) => {
        return ApiService.apiHit({
            url: 'get-domain-dns',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default DomainApi;
